<template>
  <el-card>

    <el-row>
      <el-col :span="12">
        <el-form ref="dataForm" :model="dataForm" :rules="rules">
          <el-form-item label="公司名称" prop="branch_office_name">
            <el-input v-model="dataForm.branch_office_name" placeholder="请输入公司名称" :disabled="isDisable"></el-input>
          </el-form-item>
          <el-form-item label="公司代码" prop="branch_office_code">
            <el-input v-model="dataForm.branch_office_code" placeholder="请输入公司代码" :disabled="isDisable"></el-input>
          </el-form-item>
          <el-form-item label="账单模型" prop="billing_model">
            <el-input v-model="dataForm.billing_model" placeholder="请输入账单模型" :disabled="isDisable"></el-input>
          </el-form-item>
          <el-form-item label="创建时间" prop="create_time" v-if="pageAction === 'action.view'">
            <el-input v-model="dataForm.create_time" :disabled="isDisable"></el-input>
          </el-form-item>
          <el-form-item label="更新时间" prop="update_time" v-if="pageAction === 'action.view'">
            <el-input v-model="dataForm.update_time" :disabled="isDisable"></el-input>
          </el-form-item>
          <el-form-item label="备注" prop="remark">
            <el-input type="textarea" :rows="5" v-model="dataForm.remark" :disabled="isDisable"></el-input>
          </el-form-item>
        </el-form>
      </el-col>
      <el-col :span="12"></el-col>
    </el-row>

    <el-row>
      <el-col>
        <el-button @click="goBack()">
            返回
        </el-button>
        <el-button v-if="pageAction === 'action.edit'" @click="reset()">
            重置
        </el-button>
        <el-button v-if="pageAction === 'action.add' || pageAction === 'action.edit'" type="primary" @click="save()">
            保存
        </el-button>
        <el-button v-if="pageAction === 'action.add'" type="primary" @click="saveAndAdd()">
            保存并继续添加
        </el-button>
      </el-col>
    </el-row>

  </el-card>
</template>

<script>
import {
  fetchSettingCompanyBranchOffice,
  createSettingCompanyBranchOffice,
  updateSettingCompanyBranchOffice } from "@/api/billing"
import { parseTime } from '@/utils'
export default {
  name: 'setting-company-branch-office',
  data() {
    return {
      company_id: 0,
      dataForm:{
        branch_office_name: '',
        branch_office_code: '',
        billing_model: '',
        remark: '',
        create_time: null,
        update_time: null
      },
      tempDataForm:{},
      rules:{
        branch_office_name:[
          {required: true, message: '请输入保险公司名称', trigger: 'blur'}
        ],
        branch_office_code:[
          {required: true, message: '请输入保险公司代码', trigger: 'blur'}
        ]
      },
      pageAction: '',
      id: 0,
      isDisable: false
    }
  },
  methods: {
    clearDataForm: function(){
      this.dataForm.branch_office_name = ''
      this.dataForm.branch_office_code = ''
      this.dataForm.billing_model = ''
      this.dataForm.remark = ''
    },
    showView: function(id){
      this.pageAction = 'action.view'
      this.isDisable = true
      this.getData(id)
    },
    showAddView: function(){
      this.pageAction = 'action.add'
      this.clearDataForm()
    },
    showEditView: function(id){
      this.pageAction = 'action.edit'
      this.getData(id)
    },
    goBack: function(){
      this.$router.go(-1)
    },
    reset: function(){
      this.dataForm = Object.assign({}, this.tempDataForm)
    },
    save: function(){
      if (this.pageAction === 'action.add'){
        console.log('action.add')
        this.createData(this.goBack)
      } else if (this.pageAction === 'action.edit'){
        console.log('action.edit')
        this.updateData(this.id, this.goBack)
      } else {
        this.$router.push("404")
      }
    },
    saveAndAdd: function(){
      if (this.pageAction === 'action.add'){
        this.createData(this.clearDataForm)
      } else {
        this.$router.push("404")
      }
    },
    getData: function(id){
      fetchSettingCompanyBranchOffice(id)
        .then(resp=>{
          this.dataForm.branch_office_name = resp.branch_office_name
          this.dataForm.branch_office_code= resp.branch_office_code
          this.dataForm.billing_model= resp.billing_model
          this.dataForm.remark = resp.remark
          this.dataForm.create_time = resp.create_time
          this.dataForm.update_time = resp.update_time
          this.id = resp.id
          this.tempDataForm = Object.assign({}, this.dataForm)
        }).catch(err=>{
          this.$error_message(err)
        })
    },
    createData: function(callBack){
      console.log("this.company_id:" + this.company_id)
      this.$refs.dataForm.validate(isValid =>{ if (isValid) {
          createSettingCompanyBranchOffice(this.dataForm, this.company_id).then(resp => {
            this.$message.success("创建公司信息成功")
            if (typeof callBack == 'function'){
              callBack()
            }
          }).catch(err =>{
            this.$error_message(err)
          })
        }
      })
    },
    updateData: function(id, callBack){
      this.$refs.dataForm.validate(isValid =>{
        if (isValid) {
          console.log(this.dataForm)
          console.log(id)
          updateSettingCompanyBranchOffice(this.dataForm, id).then(resp => {
            console.log('resp')
            console.log(resp)
            this.$message.success("更新公司信息成功")
            if (typeof callBack == 'function'){
              callBack()
            }
          }).catch(err =>{
            console.log('err')
            console.log(err)
            this.$error_message(err)
          })
        }
      })
    },
  },
  created() {
    if (this.$route.name === 'addSettingCompanyBranchOffice'){
      if (!this.$perm(["billing.create_setting_branch_office"])){
        this.$router.push("/401")
      }
      if (this.$route.query.company_id === undefined || this.$route.query.company_id === null){
        console.log('missing company_id')
        this.$router.push('/404')
      }
      this.company_id = this.$route.query.company_id
      this.showAddView()
    } else if (this.$route.name === 'viewSettingCompanyBranchOffice'){
      if (!this.$perm(["billing.view_setting_branch_office"])){
        this.$router.push("/401")
      }
      var id = this.$route.query.id
      if (id === undefined || id === null){
        this.$router.push("/404")
      }
      this.showView(id)
    } else if (this.$route.name === 'editSettingCompanyBranchOffice'){
      if (!this.$perm(["billing.update_setting_branch_office"])){
        this.$router.push("/401")
      }
      var id = this.$route.query.id
      if (id === undefined || id === null){
        this.$router.push("/404")
      }
      this.showEditView(id)
    } else {
      this.$router.push("/404")
    }
  }
}
</script>
